import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import { NAME, reducer } from './modules/Module';

const FeePaymentLazy = React.lazy(
	() => import(/* webpackChunkName : 'FeePayment' */ './components')
);

export default (store) => {
	store.injectReducer(NAME, reducer);
	return [
		{
			path: 'fee-payment',
			element: <AsyncLoading component={<FeePaymentLazy />} />,
		},
	];
};
